import { useEffect } from "react";

/**
 * Adds .is-visible to elements with [data-reveal] when they enter the viewport.
 * Use the `reveal` class on elements to opt in.
 */
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal, .rv");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
